export const pretifyCarrera = (s: string) => {
  if (!s) return '';
  const words = s.split(' ');
  return words
    .filter((letter) => letter != '')
    .map((word) => word[0].toUpperCase() + word.substring(1).toLowerCase())
    .join(' ');
};
